import script from "./ApplicationSteps.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationSteps.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationSteps.vue?vue&type=style&index=0&id=04128cf0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04128cf0"]])

export default __exports__